import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import AbacusTextField from '../Components/AbacusTextField';
import AbacusRadioButton from '../Components/AbacusRadioButton';
import css from './FreeTrial.module.css'
import cssCommon from './../Views/Common.module.css';
import Button from '@material-ui/core/Button';
import Util from './../Util/Util';
import CircularProgress from '@material-ui/core/CircularProgress';
import AbacusSelect from '../Components/AbacusSelect';

class FreeTrial extends Component {
  
  practiceAreas = [
    {value:"0",text:"Practice Area *"},
    {value:"1",text:"Estate Planning"},
    {value:"2",text:"Family Law"},
    {value:"3",text:"General Practice"},
    {value:"4",text:"Litigation"},
    {value:"5",text:"Personal Injury"}
  ];

  firmSizes =[
    {value:"0", text:"Firm Size *"},
    {value:"5", text:"1-5 users"},
    {value:"10", text:"6-10 users"},
    {value:"15", text:"11-15 users"},
    {value:"25", text:"15+ users"} 
  ];

  currentState={
    practiceArea: "0",
    practiceAreas: this.practiceAreas,
    firmSize: "0",
    firmSizes: this.firmSizes

  };

  // Constructor initiate callback methods and sets initial state
  constructor(props) {
    super(props);  

    this.data = props.data;
    this.data.Service.FreeTrialCallback = this.freeTrialCallback.bind(this);
    this.isOTFreeTrial = props.isOTFreeTrial;

    // Keep state in the current state structure because the state can be changed only once per event.
    this.clearState();

    // Set state
    this.state = {...this.currentState}   
    this.labelText= this.isOTFreeTrial? "Create Office Tools Hosted Exchange Account" :"Create Amicus Hosted Exchange Account";
  }

  onChange(value,event){
    this.currentState.IsValid = true;
    if(value === "AMX"){
      this.currentState.is365 = false;
    }else if(value === "O365"){
      this.currentState.is365 = true;
    }else if(value === "FirstName"){
      this.currentState.firstName = event.target.value;
    }else if(value === "FirmName"){
      this.currentState.firmName = event.target.value;
    }else if(value === "LastName"){
      this.currentState.lastName = event.target.value;
    }else if(value === "Email"){
      this.currentState.email = event.target.value;
    }else if(value === "Phone"){
      this.currentState.phone = event.target.value;
    }

    this.isValidEmail();
    this.validateEmpty();

    this.setState({...this.currentState});
  }

  isValidEmail(){
    let util = new Util();
      if(util.trim(this.currentState.email).length !== 0 )
      {
        let isValid = util.isValidEmailAddress(this.currentState.email);
        if(!isValid){
          this.currentState.Email_ErrorText = "Invalid Email Address.";
          this.currentState.Email_Error = true;
          this.currentState.IsValid = false;
        }else{
          this.currentState.Email_ErrorText = "";
          this.currentState.Email_Error = false;
          this.currentState.IsValid = true;
        }
      }else{
        this.currentState.Email_ErrorText = "";
        this.currentState.Email_Error = false;
        this.currentState.IsValid = true;
      }
  }

  validateEmpty(){
    let util = new Util();
    if(util.trim(this.currentState.firstName) === "" ||
      util.trim(this.currentState.firmName) === "" ||
      util.trim(this.currentState.lastName) === "" ||
      util.trim(this.currentState.email) === "" ||
      util.trim(this.currentState.phone) === "" ||
      this.currentState.firmSize === "0" ||
      this.currentState.practiceArea === "0" && this.isOTFreeTrial !== true
    ){
      this.currentState.IsValid = false;
    }
  }

  freeTrialCallback(success){
    if(!success)
    this.setState({showProgress:false});
    else
    this.clear();
  }

  submit(){
    this.setState({showProgress:true});
    let request = null;

    if(this.isOTFreeTrial !== true)
    {
    request = {
      FirstName: this.state.firstName,
      LastName: this.state.lastName,
      FirmName:this.state.firmName,
      Email:this.state.email,
      Phone:this.state.phone,
      SalesRepEmailAddress: this.data.Login.Email,
      Secret:this.data.Login.Secret,
      isAMSX: !this.state.is365,
      PracticeArea:this.state.practiceArea,
      FirmSize:this.state.firmSize
    }
    } 
    else{
    request = {
      FirstName: this.state.firstName,
      LastName: this.state.lastName,
      FirmName:this.state.firmName,
      Email:this.state.email,
      Phone:this.state.phone,
      SalesRepEmailAddress: this.data.Login.Email,
      Secret:this.data.Login.Secret,
      isAMSX: !this.state.is365,
      FirmSize:this.state.firmSize
    }
  }

    this.data.Service.CreateFreeTrial(request, this.isOTFreeTrial);
  }

  clearState(){
    this.currentState = {
      firstName: "",
      firmName: "",
      lastName: "",
      email: "",
      phone: "",
      is365: true,
      Email_ErrorText: "",
      Email_Error: false,
      IsValid: false,
      showProgress: false,
      practiceAreas: this.practiceAreas,
      practiceArea: "0",
      firmSizes: this.firmSizes,
      firmSize: "0"
    }
  }

  clear(){
    this.clearState();
    this.setState({...this.currentState});
  }

    // Drop Down Change Events
    dropDownChange(controlName, event){
      this.currentState.IsValid = true;

       if(controlName === "PracticeArea"){
         this.currentState.practiceArea = event.target.value;
       }
       else if(controlName === "FirmSize"){
        this.currentState.firmSize = event.target.value;
       }
 
    let practiceAreas = this.currentState.practiceAreas;
    let practiceArea = this.currentState.practiceArea;

    let firmSize = this.currentState.firmSize;
    let firmSizes = this.currentState.firmSizes;

      this.setState({
        practiceAreas:practiceAreas,
        practiceArea:practiceArea,
        firmSizes:firmSizes,
        firmSize:firmSize
        
      });

      this.validateEmpty();

    }


  render() {
    return (
      <div>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div className={css.office_label}>Select Email Setting for a New {this.isOTFreeTrial? "Office Tools" :"Amicus Cloud"} Free Trial:</div>
          </Grid>

          <Grid item xs={6}>  
            <AbacusRadioButton label="Firm already has Office 365 (or own Exchange)" checked={this.state.is365} onChange={this.onChange.bind(this,"O365")}></AbacusRadioButton>
          </Grid>
          <Grid item xs={6}>  
            <AbacusRadioButton label={this.labelText} checked={!this.state.is365} onChange={this.onChange.bind(this,"AMX")}></AbacusRadioButton>
          </Grid>

          <Grid style={{margin:"0px"}} item xs={6}>  
            <div className={css.subtext_exchange}>Use firm's Office 365 (or own Exchange) so they can see their own data in the free trial.</div>
          </Grid>
          <Grid item xs={6}>  
            <div className={css.subtext_exchange}>Firm does not already have Microsoft Exchange.  Create a new account with sample data.</div>
          </Grid>

          <Grid item xs={12}>  
            <div style={{height:"30px"}}></div>
          </Grid>

          <Grid item xs={12}>  
            <div className={cssCommon.separator}></div>
          </Grid>

          <Grid item xs={12}>  
            <div style={{height:"10px"}}></div>
          </Grid>

          <Grid item xs={4}>  
            <AbacusTextField required={true} disabled={false} value={this.state.firstName} style={{marginTop:"0px",width:"300px"}} Name="First Name" helperText="" onChange={this.onChange.bind(this,"FirstName")}></AbacusTextField>
          </Grid>
          <Grid item xs={8}>  
            <AbacusTextField required={true} disabled={false} value={this.state.firmName} style={{marginTop:"0px",width:"600px"}} Name="Firm Name" helperText="" onChange={this.onChange.bind(this,"FirmName")}></AbacusTextField>
          </Grid>

          <Grid item xs={4}>  
            <AbacusTextField required={true} disabled={false} value={this.state.lastName} style={{marginTop:"0px",width:"300px"}} Name="Last Name" helperText="" onChange={this.onChange.bind(this,"LastName")}></AbacusTextField>
          </Grid>
          <Grid item xs={8}>  
            <AbacusTextField required={true} disabled={false} value={this.state.email} errorText={this.state.Email_ErrorText} error={this.state.Email_Error} style={{marginTop:"0px",width:"600px"}} Name="Email" helperText="" onChange={this.onChange.bind(this,"Email")}></AbacusTextField>
          </Grid>

          <Grid item xs={4}>  
            <AbacusTextField IsNumeric={true} required={true} disabled={false} value={this.state.phone} style={{marginTop:"0px",width:"300px"}} Name="Phone" helperText="" onChange={this.onChange.bind(this,"Phone")}></AbacusTextField>
          </Grid>

          <Grid item xs={4}>  
          {(this.currentState.firmSize === "0") ?  
            <AbacusSelect error={false} style={{width:"265px", textAlign:"left", opacity: 0.8}} value={this.state.firmSize} list={this.state.firmSizes} label="" onChange={this.dropDownChange.bind(this,"FirmSize")}></AbacusSelect>
            : <AbacusSelect error={false} style={{width:"265px", textAlign:"left"}} value={this.state.firmSize} list={this.state.firmSizes} label="Firm Size*" onChange={this.dropDownChange.bind(this,"FirmSize")}></AbacusSelect> 
          }    
          </Grid>

        {(this.isOTFreeTrial !== true) ? 
          <Grid item xs={4}>  
          {(this.currentState.practiceArea === "0") ? 
            <AbacusSelect error={false} style={{width:"265px", textAlign: "left", opacity: 0.8}} value={this.state.practiceArea} list={this.state.practiceAreas} label="" onChange={this.dropDownChange.bind(this,"PracticeArea")}></AbacusSelect>
           : <AbacusSelect error={false} style={{width:"265px",  textAlign: "left"}} value={this.state.practiceArea} list={this.state.practiceAreas} label="Practice Area*" onChange={this.dropDownChange.bind(this,"PracticeArea")}></AbacusSelect>
          }  
          </Grid>    : null}

          <Grid item xs={5}>  
          </Grid>
          <Grid item xs={2}>  
            {this.state.showProgress?<CircularProgress style={{marginTop:"0px"}} />:null}
          </Grid>
          <Grid item xs={2}>  
            {!this.state.showProgress?<Button className={css.button_style} onClick={this.clear.bind(this)} variant="outlined" color="primary">
              CLEAR
            </Button>:null}
          </Grid>
          <Grid item xs={2}>  
            {!this.state.showProgress?<Button disabled={!this.currentState.IsValid} className={css.button_style} onClick={this.submit.bind(this)} variant="contained" color="primary">
              SUBMIT
            </Button>:null}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default FreeTrial;